export const InfoBlocksEnum = {
    rating: "rating",
    settings: "settings",
    notifications: "notifications",
    chat: "chat",
    meetings: "meetings",
    sessions: "sessions",
    deviceTest: "deviceTest",
    favorites: "favorites",
    empty: ""
} as const;

export type InfoBlocksEnum = typeof InfoBlocksEnum[keyof typeof InfoBlocksEnum];